import {Component, ElementRef, OnDestroy, OnInit, ViewChild, inject} from '@angular/core';
import {sessionStoreOrGetIfNull} from '../../../_utils/storage';
import {MDS_REQUEST_CACHE_KEY} from '../../../_constants/constants';
import {getStateFromRouter} from '../../../_utils/nav';
import {ConsumerRequestReport} from '../ifs-report/ifs-report.component';
import {Router} from '@angular/router';
import {currentTimeFormatted, reformatDate, reformatPhone} from '../../../_utils/lang';
import {I18nService} from '../../../_services/gui/i18n.service';
import {TabBarService} from '../../../_services/gui/tab-bar.service';
import {ConsumerReport} from '../../../_data/reports/consumer/consumer-report';
import {addresses, names, primaryGivenNames, primaryName, primaryPhone} from 'src/app/_utils/consumer';
import {CONSUMER_PDF_CSS} from '../../../_constants/pdf-report/consumer-css';
import {SidenavComponent} from '../../../sidenav/sidenav.component';
import {CardComponent} from '../../../sidenav/card/card.component';
import {PdfButtonBarComponent} from '../../../common/pdf-button-bar/pdf-button-bar.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-aml-report',
    templateUrl: './mds-report.component.html',
    styleUrls: ['./mds-report.component.scss'],
    imports: [SidenavComponent, CardComponent, PdfButtonBarComponent, TranslateModule]
})
export class MdsReportComponent implements OnInit, OnDestroy {

  @ViewChild('creditReport', {read: ElementRef}) creditReport: ElementRef;

  reformatDate = reformatDate;
  reformatPhone = reformatPhone;

  names = names;
  primaryName = primaryName;
  primaryGivenNames = primaryGivenNames;
  addresses = addresses;
  primaryPhone = primaryPhone;
  ifsReportCss = CONSUMER_PDF_CSS;

  readonly consumerRequestReport: ConsumerRequestReport;
  readonly consumerReport: ConsumerReport;
  currentDateTime: string;
  
  i18nService = inject(I18nService);
  private useReportCache: boolean = false;
  private router = inject(Router);
  private tabBarService = inject(TabBarService);

  constructor() {
    const router = this.router;

    [this.useReportCache, this.consumerRequestReport] = sessionStoreOrGetIfNull(MDS_REQUEST_CACHE_KEY, getStateFromRouter(router));
    this.consumerReport = this.consumerRequestReport?.report;
  }

  ngOnInit(): void {
    this.i18nService.setTitle('title.results');
    this.tabBarService.show();
    this.currentDateTime = currentTimeFormatted();
  }

  ngOnDestroy() {
    //If the user intentionally navigates away from the report, clear the storage for the request/response.
    sessionStorage.removeItem(MDS_REQUEST_CACHE_KEY);
  }

}
